// MBQ OCT 2025 RESTYLING
import React from 'react'
import PropTypes from 'prop-types'
import {
  Nav, UncontrolledDropdown, DropdownToggle,
  DropdownMenu, DropdownItem
} from 'reactstrap'
import envSettings from '../../../globals/envSettings'

const SimpleNavList = ({ content, userInfo }) => (
  <Nav className="ml-auto" navbar>
    {userInfo && (
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle className="headerOUP__dropdown__toggle" nav caret>
          <span>
            <span className="glyphicon glyphicon-user"></span>
            {userInfo.name}
          </span>
        </DropdownToggle>
        <DropdownMenu className="headerOUP__dropdown" right>
          <DropdownItem className="headerOUP__dropdown__item" href={envSettings.LOGOUT_URL} >
            <span className="glyphicon glyphicon-remove mr-2"></span>
            {content.header.logout_text}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    )}
  </Nav>
)

SimpleNavList.propTypes = {
  userInfo: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool
  ]),
  content: PropTypes.object
}

export default SimpleNavList